import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-brown-dark text-cream py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-playfair font-bold text-turmeric mb-4">
              Chaat-De-Licious
            </h3>
            <p className="text-cream-secondary text-sm font-caveat text-lg">
              Handcrafted Gourmet Fun Snacks
            </p>
            <p className="text-cream/80 mt-4 text-sm">
              Pimple Saudagar, Pune, Maharashtra
            </p>
          </div>

          <div>
            <h4 className="text-lg font-playfair font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/menu" className="text-cream/80 hover:text-turmeric transition-colors" data-testid="footer-menu-link">
                  Menu
                </Link>
              </li>
              <li>
                <Link to="/new-additions" className="text-cream/80 hover:text-turmeric transition-colors" data-testid="footer-new-additions-link">
                  New Additions
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-cream/80 hover:text-turmeric transition-colors" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-cream/80 hover:text-turmeric transition-colors" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-playfair font-bold mb-4">Our Promise</h4>
            <p className="text-cream/80 text-sm leading-relaxed">
              Fresh ingredients, healthy options, and gourmet taste in every bite. Made with love for food enthusiasts.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-cream/20 text-center">
          <p className="text-cream/60 text-sm flex items-center justify-center gap-2">
            Made with <Heart size={16} className="text-spice fill-spice" /> for Food Lovers
          </p>
          <p className="text-cream/60 text-xs mt-2">
            © 2024 Chaat-De-licious. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};